module.exports = __webpack_public_path__ + "static/media/mc_settings_pulse.ae966e8e.svg";